import { Typography } from '@mui/material';
import { updateMeta } from '../../../redux/meta';
import { useAppDispatch } from '../../../pages/assessment';
import { AssessmentButtons, AssessmentCard } from '../shared';

const SensitiveInformationWarning = () => {
  const dispatch = useAppDispatch();

  return (
    <>
      <AssessmentCard>
        <Typography>
          To match you with the right psychiatrist, we need to understand your
          history of diagnoses, your potential for self-harm, and what
          substances you put in your body.
        </Typography>
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          children: 'I understand',
          onClick: () => dispatch(updateMeta()),
        }}
      />
    </>
  );
};

export default SensitiveInformationWarning;
